import {
  ListsState,
  LoadListDataAction,
  SetListDataAction,
  SetListsAction,
} from '$store/lists/interface';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';

const initialState: ListsState = {
  lists: {},
  custom: [],
  listsDataMap: {},
  users: [],
  isLoading: true,
  isListLoading: true,
};

export const { actions, reducer } = createSlice({
  name: 'lists',
  initialState,
  reducers: {
    loadLists(state) {
      state.isLoading = true;
    },
    setLists(state, action: SetListsAction) {
      const { users, custom, ...lists } = action.payload;

      state.lists = lists;
      state.custom = custom || [];
      state.users = users;
      state.isLoading = false;
      state.isListLoading = true;
    },
    loadListData(state, action: LoadListDataAction) {
      state.isListLoading = true;
    },
    setListData(state, action: SetListDataAction) {
      const { listData, listId } = action.payload;

      state.listsDataMap[listId] = listData;
      state.isListLoading = false;
    },
  },
});

export { reducer as listsReducer, actions as listsActions };

export const listsSelector = (state: RootState) => state.lists;
